import InterfaceStatus from '@/components/interface-status';
import ManageReleaseNotes from '@/components/manage-release-notes';
import { INTERFACE_STATUS } from '@/utils/constants';

const RenderActiveContent = ({ activeView }: { activeView: string }) => {
  if (activeView === INTERFACE_STATUS) {
    return <InterfaceStatus />;
  }

  return <ManageReleaseNotes />;
};
export default RenderActiveContent;
